document.querySelectorAll('form.cart').forEach(function(productForm) {
    class TotalPriceSidebar {
        constructor(productForm) {
            //Переменные
            this.sidebar = productForm.querySelector('.total-price-sidebar');
            this.isNeedUpdateContent = true;
            this.pdfPromise = undefined;
            this.product = productForm.classList.contains('variations_form') ? current_variation : JSON.parse(productForm.dataset.product);
            this.priceItems = [];

            //События
            //Установить статус обновления контента сайдбара
            jQuery(productForm).on('show_variation', (event, variation) => {
                this.isNeedUpdateContent = true;
                this.product = variation;
            });
            jQuery(productForm).on('variation_corner_change', () => this.isNeedUpdateContent = true);
            jQuery(productForm).on('fabric_changed', () => this.isNeedUpdateContent = true);
            jQuery(productForm).on('options_changed', () => this.isNeedUpdateContent = true);
            //Открыть сайдбар
            jQuery(document.body).on('click', '.total-price-trigger', () => {
                //Открыть оверлей
                jQuery(document.body).trigger('overlay_open');

                this.openSidebar();
            });
            //Закрыть сайдбар при закрытии оверлея
            jQuery(document.body).on('overlay_close', () => this.closeSidebar());
            //Скачать PDF
            jQuery(this.sidebar).on('click', '.pdf-trigger', async () => {
                await this.loadPDFLib();

                this.downloadPDF();
            });
        }

        openSidebar() {
            this.sidebar.classList.add('open');

            //Обновить содержимое сайдбара при открытии
            if (this.isNeedUpdateContent) this.updateContent();
        }

        closeSidebar() {
            this.sidebar.classList.remove('open');
        }

        updateContent() {
            //Меняем статус обновления контента
            this.isNeedUpdateContent = false;

            //Подготавливаем данные
            this.priceItems = [];
            //Цена товара
            this.priceItems.push({
                'type': 'main',
                'title': 'Базовая стоимость',
                'price': new Intl.NumberFormat("ru-RU").format(this.product['display_price']) + ' ₽'
            });
            let totalPrice = this.product['display_price'];
            //Цена ткани
            if (Object.keys(current_fabric).length && Object.keys(current_fabric_category).length) {
                const categoryName = /^\d+$/.test(current_fabric_category['name'])
                    ? Number(current_fabric_category['name']) : current_fabric_category['name'];
                const price = calcFabricPrice(this.product['display_price'], current_fabric_category);

                this.priceItems.push({
                    'type': 'main',
                    'title': 'Материал обивки',
                    'price': price ? new Intl.NumberFormat("ru-RU").format(price) + ' ₽' : 'бесплатно'
                });

                this.priceItems.push({
                    'type': 'substring',
                    'title': 'Ткань: ' + current_fabric['title'] + ' (' + categoryName + ' категория)',
                    'price': price ? new Intl.NumberFormat("ru-RU").format(price) + ' ₽' : 'бесплатно'
                });
                totalPrice += price;
            }
            //Цены опций
            if (Object.keys(current_options).length && Object.keys(current_options_variations).length) {
                current_options.forEach(option => {
                    const variations = current_options_variations.filter(variation => variation['option_id'] === option['id']);

                    let optionPrice = 0;
                    const variationPrices = [];
                    variations.forEach(variation => {
                        let price = calcOptionPrice(this.product['display_price'], variation);
                        let variationPrice;
                        if (variation['count'] || variation['count'] === 0) {
                            price = price * variation['count'];
                            variationPrice = price ? new Intl.NumberFormat("ru-RU").format(price) + 'x' + variation['count']
                                + ' = ' + new Intl.NumberFormat("ru-RU").format(price) + ' ₽' : 'бесплатно';
                        } else {
                            variationPrice = price ? new Intl.NumberFormat("ru-RU").format(price) + ' ₽' : 'бесплатно';
                        }

                        variationPrices.push({
                            'type': 'substring',
                            'title': variation['count'] ? variation['title'] + ' x' + variation['count'] : variation['title'],
                            'price': variationPrice
                        });
                        optionPrice += price;
                    });

                    this.priceItems.push({
                        'type': 'main',
                        'title': option['title'],
                        'price': optionPrice ? new Intl.NumberFormat("ru-RU").format(optionPrice) + ' ₽' : 'бесплатно'
                    });
                    this.priceItems = this.priceItems.concat(variationPrices);
                    totalPrice += optionPrice;
                });
            }
            //Итоговая цена
            this.priceItems.push({
                'type': 'total',
                'title': 'Итого',
                'price': totalPrice ? new Intl.NumberFormat("ru-RU").format(totalPrice) + ' ₽' : 'бесплатно'
            });

            //Формируем контентную область
            const content = this.sidebar.querySelector('.content');
            content.innerHTML = '';

            const productWrapper = document.createElement('div');
            productWrapper.classList.add('total-price-sidebar__wrapper');
            content.appendChild(productWrapper);

            const preview = document.createElement('img');
            preview.classList.add('total-price-sidebar__preview');
            preview.src = this.product['image']['thumb_src'];
            preview.sizes = '180px';
            preview.srcset = this.product['image']['srcset'];
            productWrapper.appendChild(preview);

            const productInfo = document.createElement('div');
            productInfo.classList.add('total-price-sidebar__info');
            productWrapper.appendChild(productInfo);

            const subtitle = document.createElement('span');
            subtitle.classList.add('total-price-sidebar__subtitle');
            subtitle.innerHTML = this.product['title'];
            productInfo.appendChild(subtitle);

            if (typeof this.product['attributes'] === 'object' && Object.keys(this.product['attributes']).length) {
                let attributeValue = Object.values(this.product['attributes'])[0];
                attributeValue = this.product['attribute_labels'][attributeValue];

                let cornerName = '';
                if (current_variation_corner === 'left') {
                    cornerName = 'левый';
                } else if (current_variation_corner === 'right') {
                    cornerName = 'правый';
                }

                const label = document.createElement('span');
                label.classList.add('total-price-sidebar__label');
                label.innerHTML = cornerName ? attributeValue + ', ' + cornerName : attributeValue;
                productInfo.appendChild(label);
            }

            const list = document.createElement('ul');
            list.classList.add('total-price-sidebar__list');
            content.appendChild(list);

            this.priceItems.forEach(priceObject => {
                const item = document.createElement('li');
                item.classList.add('total-price-sidebar__item');
                if (priceObject['type'] === 'main') item.classList.add('main');
                if (priceObject['type'] === 'substring') item.classList.add('substring');
                if (priceObject['type'] === 'total') item.classList.add('total');
                list.append(item);

                const itemTitle = document.createElement('span');
                itemTitle.classList.add('total-price-sidebar__item-title');
                itemTitle.innerHTML = priceObject['title'];
                item.appendChild(itemTitle);

                const itemPrice = document.createElement('span');
                itemPrice.classList.add('total-price-sidebar__item-price');
                itemPrice.innerHTML = priceObject['price'];
                item.appendChild(itemPrice);
            });
        }

        async loadPDFLib() {
            const urls = [
                '/wp-content/themes/savoy-child/assets/js/pdfmake.min.js',
                '/wp-content/themes/savoy-child/assets/js/vfs_fonts.js'
            ];

            if (this.pdfPromise) return this.pdfPromise;

            this.pdfPromise = (async () => {
                for (const url of urls) {
                    await new Promise((resolve, reject) => {
                        const script = document.createElement('script');
                        script.src = url;
                        script.async = false;
                        script.onload = resolve;
                        script.onerror = () => { this.pdfPromise = null; reject(); };
                        document.head.appendChild(script);
                    });
                }
            })();

            return this.pdfPromise;
        }

        async downloadPDF() {
            const pdfPrice = {
                content: [
                    {
                        text: 'Расчёт стоимости изделия:',
                        fontSize: '28',
                        alignment: 'center'
                    },
                    {
                        text: this.product['title'],
                        fontSize: 28,
                        alignment: 'center',
                        marginBottom: 40
                    }
                ]
            };

            const base64Img = await getBase64Image(this.product['image']['thumb_src']);
            if (base64Img) {
                pdfPrice['content'].push({
                    'image': base64Img,
                    'alignment': 'right',
                    'fit': [250, 250]
                });
            }

            const pdfPriceTable = {
                layout: 'noBorders',
                table: {
                    headerRows: 1,
                    widths: ['*', 'auto'],
                    body: []
                }
            };

            this.priceItems.forEach(priceObject => {
                if (priceObject['type'] === 'main') {
                    pdfPriceTable['table']['body'].push([
                        { 'text': priceObject['title'], 'fontSize': 16, 'marginBottom': 5 },
                        { 'text': priceObject['price'], 'fontSize': 16, 'fontWeight': 500, 'alignment': 'right' }
                    ]);
                } else if (priceObject['type'] === 'substring') {
                    pdfPriceTable['table']['body'].push([
                        { 'text': priceObject['title'], 'fontSize': 16, 'fontWeight': 300, 'marginLeft': 16, 'marginBottom': 4 },
                        { 'text': priceObject['price'], 'fontSize': 14, 'fontWeight': 300, 'alignment': 'right' }
                    ]);
                } else if (priceObject['type'] === 'total') {
                    pdfPriceTable['table']['body'].push([
                        {'text': priceObject['title'], 'fontSize': 20, 'fontWeight': 500, 'marginTop': 36},
                        { 'text': priceObject['price'], 'fontSize': 20, 'fontWeight': 500, 'marginTop': 36, 'alignment': 'right' }
                    ]);
                }
            });
            pdfPrice['content'].push(pdfPriceTable);

            pdfMake.createPdf(pdfPrice).download('file.pdf');
        }
    }

    if (productForm.classList.contains('variations_form')) {
        jQuery(productForm).one('show_variation', () => {
            new TotalPriceSidebar(productForm);
        });
    } else {
        new TotalPriceSidebar(productForm);
    }
});